import { CloseButton as MantineCloseButton } from '@mantine/core';
import { X } from 'lucide-react';

export const CloseButton = MantineCloseButton.extend({
	defaultProps: {
		icon: <X />,
	},
});
